module.exports = __webpack_public_path__ + "img/group_info_edit.990e98ce.svg";